import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import Register from './components/auth/Register';
import Login from './components/auth/Login';
import Projects from './ProjectsDemo';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import AdminPage from './pages/admin/AdminPage';

const PublicRoutes = ({
  userIdToken,
  projectIdToken,
  onLogin,
  onProjectAccess,
  handleStorageChange,
  isTeamsInitialized,
}) => {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/login"
          element={
            <Login onLogin={onLogin} isTeamsInitialized={isTeamsInitialized} />
          }
        />
        <Route path="/sign-up" element={<Register onLogin={onLogin} />} />
        <Route path="*" element={<Navigate to="/login" />} />

        {/* Conditional routes */}
        {userIdToken && (
          <Route
            path="/projects"
            element={
              <Projects
                userIdToken={userIdToken}
                onProjectAccess={onProjectAccess}
                handleStorageChange={handleStorageChange}
              />
            }
          />
        )}
        {userIdToken && (
          <Route
            path="/projects"
            element={
              <Projects
                userIdToken={userIdToken}
                onProjectAccess={onProjectAccess}
                handleStorageChange={handleStorageChange}
              />
            }
          />
        )}

        {/* Pass userIdToken to the protected route wrapper */}
        {userIdToken && (
          <Route
            path="/admin-control-panel"
            element={
              <ProtectedAdminRoute userIdToken={userIdToken}>
                <AdminPage />
              </ProtectedAdminRoute>
            }
          />
        )}

        {!userIdToken && <Route path="*" element={<Navigate to="/login" />} />}
        {userIdToken && (
          <Route path="*" element={<Navigate to="/projects" />} />
        )}
      </Routes>
    </div>
  );
};

export default PublicRoutes;
